import classNames from "classnames";
import {
  AscBadgeWithTitleAndDescriptionPropsI,
  AscBadgeWithTitleAndDescriptionTypes,
} from "./AscBadgeWithTitleAndDescription.type";
import styles from "./AscBadgeWithTitleAndDescription.module.scss";
import {
  BlueTrophyBadge,
  LargeBlueTicket,
  LargeGreenTicket,
  LargeOrangeTicket,
  LargePinkTicket,
  LargePurpleTicket,
  OrangeTrophyBadge,
  PinkTrophyBadge,
} from "../AscIllustrations";
import AscImage from "../AscImage/AscImage";

function AscBadgeWithTitleAndDescription({
  badge,
  title,
  description,
  textColor = "black",
  className,
  badgeClassName,
  titleClassName,
  descriptionClassName,
  loading = false,
  badgeImageUrl,
  isBadgeEarned = false,
}: AscBadgeWithTitleAndDescriptionPropsI) {
  const getBadge = (badge: AscBadgeWithTitleAndDescriptionTypes) => {
    switch (badge) {
      case "blue-trophy":
        return (
          <BlueTrophyBadge data-testid={"badge"} className={badgeClassName} />
        );
      case "orange-trophy":
        return <OrangeTrophyBadge className={badgeClassName} />;
      case "pink-trophy":
        return <PinkTrophyBadge className={badgeClassName} />;
      case "TEAL":
        return <LargeBlueTicket className={badgeClassName} />;
      case "GREEN":
        return <LargeGreenTicket className={badgeClassName} />;
      case "ORANGE":
        return <LargeOrangeTicket className={badgeClassName} />;
      case "PINK":
        return <LargePinkTicket className={badgeClassName} />;
      case "PURPLE":
        return <LargePurpleTicket className={badgeClassName} />;
      default:
        return null;
    }
  };

  return (
    <div
      className={classNames(styles.ground, className, {
        [styles.loading]: loading,
      })}
    >
      <div
        className={classNames(styles.badgeWrapper, {
          [styles.earned]: isBadgeEarned,
        })}
      >
        {badgeImageUrl ? (
          <AscImage
            src={badgeImageUrl}
            className={classNames(styles.badgeImage, badgeClassName)}
          />
        ) : (
          getBadge(badge)
        )}
      </div>
      <div className={classNames(styles.content, styles[textColor])}>
        <div className={classNames(styles.title, titleClassName)}>{title}</div>
        <div className={classNames(styles.description, descriptionClassName)}>
          {description}
        </div>
      </div>
    </div>
  );
}

export default AscBadgeWithTitleAndDescription;
